module.exports = __webpack_public_path__ + "static/icon_color_school-a56b641cd6a2dae2a3fbfb83b79166d5.png";